import { msalConfig } from "./config/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
await msalInstance.handleRedirectPromise();

const Account = msalInstance.getAllAccounts()[0];
export { msalInstance, Account };
